import { ROLE_TYPE_PROVIDER } from "../../../constants/RegisterConstants";
import ResidentEntryLogPageContent from "../components/ResidentEntryLogPageContent";

const ProviderIncidentReportPage = () => (
  <ResidentEntryLogPageContent
    expectedRole={ROLE_TYPE_PROVIDER}
    entryType="incident"
    pageTitle="Incident Reports"
    pageSubtitle="Write down serious or unusual events, what was done, and who was updated."
    sectionTitle="Incident Reports"
    sectionDescription=""
    defaultComposerVisible={true}
    showComposerToggleButton={true}
    compactActionBar={true}
    compactDraftsAction={true}
    loadEntriesPage={(backendAPIStore, residentId, options) =>
      backendAPIStore.getResidentIncidentReportsPage(residentId, options)}
    createEntry={(backendAPIStore, residentId, payload) =>
      backendAPIStore.createResidentIncidentReport(residentId, payload)}
    updateEntry={(backendAPIStore, residentId, payload) =>
      backendAPIStore.updateResidentIncidentReport(residentId, payload)}
    deleteDraft={(backendAPIStore, residentId, entryLogId) =>
      backendAPIStore.deleteResidentIncidentReport(residentId, entryLogId)}
    canEditEntry={() => true}
    enableMonthlyReport={true}
    monthlyReportTitle="Generate Reports"
    monthlyReportDescription="Review the month's incident reports and export a clean summary for your records."
    loadMonthlyReport={(backendAPIStore, residentId, options) =>
      backendAPIStore.getResidentIncidentReportMonthlyDataset(residentId, options)}
    generateMonthlyReportDocument={(backendAPIStore, residentId, requestBody) =>
      backendAPIStore.generateResidentIncidentReportDocument(residentId, requestBody)}
    readOnlyArchivedResident={true}
  />
);

export default ProviderIncidentReportPage;
